import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mt-2 mb-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "pt-2"
}
const _hoisted_5 = {
  key: 0,
  class: "text-small"
}
const _hoisted_6 = { class: "staticTable text-small mt-2 mb-2" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "d-flex flex-row mt-2 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Right = _resolveComponent("Right")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_DocumentCopy = _resolveComponent("DocumentCopy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "ds-section-title-medium" }, "System or machine challenge", -1)),
      _createVNode(_component_el_input, {
        modelValue: _ctx.inputChallenge,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputChallenge) = $event)),
        onKeyup: _ctx.readChallenge,
        size: "large",
        class: _normalizeClass({ warning: _ctx.challenge.length > 0 && !_ctx.isValid})
      }, null, 8, ["modelValue", "onKeyup", "class"])
    ]),
    (_ctx.challenge.length > 0 && !_ctx.isValid)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[3] || (_cache[3] = [
          _createElementVNode("p", { class: "text-small text-warning" }, "The challenge is not valid.", -1)
        ])))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.fields.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Challenge metadata"))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: field.name
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("strong", null, _toDisplayString(field.name), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString(field.value), 1)
              ]))
            }), 128))
          ]),
          (_ctx.isValid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_el_button, {
                  class: "mt-2 mb-2",
                  type: "primary",
                  onClick: _ctx.createLicense
                }, {
                  default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createTextVNode("GENERATE LICENSE KEY ", -1)),
                    _createVNode(_component_el_icon, {
                      size: 15,
                      class: "ml-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Right)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1,
                  __: [4]
                }, 8, ["onClick"]),
                (_ctx.generatedLicenseKey !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-small" }, "Generated license key", -1)),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_input, {
                          id: "licenseKeyField",
                          type: "textarea",
                          rows: 1,
                          modelValue: _ctx.generatedLicenseKey,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.generatedLicenseKey) = $event)),
                          readonly: true,
                          clearable: false
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_el_button, {
                          class: "ml-2 mr-2",
                          style: {"height":"fit-content"},
                          type: "primary",
                          circle: "",
                          onClick: _ctx.copyLicenseToClipBoard
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, { size: 15 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DocumentCopy)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}